export const apiBaseURL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
